module.exports = __webpack_public_path__ + "media/images/homepage/heart-icon-2236b7edf62b36754e7ba19f60203acc.svg";